import { startThrottledListener } from '@betty/toolkit/state';
import { fetchPromo, getPromo } from './landingPromo.slice';

startThrottledListener({
  actionCreator: fetchPromo,
  effect: (_, { dispatch }) => {
    dispatch(getPromo());
  },
});
